import config from 'config/config'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { initialize } from 'redux-form'
import { Icon, Image, Table } from 'semantic-ui-react'
import placeholder from 'images/placeholder.png'
import placeholder_dark from 'images/placeholder_inverted.png'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      initialize,
    },
    dispatch
  )
}

class MediaListItem extends React.Component {
  getIcon(medium) {
    const dark = config.theme.dark

    if (medium && medium.content_type.match(/^image/))
      return <Image fluid src={config.api_url + medium.small_url} />
    if (medium && medium.content_type === 'application/pdf')
      return <Icon name="file pdf outline" size="large" />
    return <Image src={dark ? placeholder_dark : placeholder} fluid />
  }

  render() {
    const { medium, action, title, initialize } = this.props

    return (
      <tr>
        <Table.Cell width={2} children={this.getIcon(medium)} />
        <Table.Cell width={8} className="info">
          <strong>{title}</strong>
          <br />
          <span className="german tag ellipsis">
            {medium && medium.title_de}
          </span>
          <span className="french tag ellipsis">
            {medium && medium.title_fr}
          </span>
        </Table.Cell>
        <Table.Cell collapsing width={2}>
          <Icon
            link
            {...config.icons.edit}
            onClick={(event) => {
              event.preventDefault()
              initialize('mediaBrowserEdit', {
                id: medium.id,
                title_de: medium.title_de,
                title_fr: medium.title_fr,
              })
            }}
          />&nbsp;
          <Icon {...config.icons.delete} onClick={action} link />
        </Table.Cell>
      </tr>
    )
  }
}

MediaListItem = connect(mapStateToProps, mapDispatchToProps)(MediaListItem)
export default MediaListItem



// WEBPACK FOOTER //
// ./src/components/shared/MediaBrowser/MediaListItem.jsx